import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  data: [],
  page: 1,
  perPage: 10,
  count: 0,
  isLoading: false,
  isError: false,
  error: "",

  isUpdating: false,
  isUpdateSuccess: false,

  filters: {
    status: "",
  },
};

const jobPromotionSlice = createSlice({
  name: "jobPromotion",
  initialState: initialState,
  reducers: {
    getJobPromotions: (state) => {
      state.isLoading = true;
    },
    getJobPromotionsSuccess: (state, action) => {
      state.data = action.payload.rows;
      state.page = +action.payload.page;
      state.perPage = +action.payload.perPage;
      state.count = action.payload.count;
      state.isLoading = false;
      state.isError = false;
      state.error = "";
    },
    getJobPromotionsFailed: (state, action) => {
      state.data = [];
      state.isLoading = false;
      state.isError = true;
      state.error = action.payload;
    },

    updateJobPromotionStatus: (state) => {
      state.isUpdating = true;
      state.isUpdateSuccess = false;
    },
    updateJobPromotionStatusSuccess: (state, action) => {
      state.data = state.data.map((item) => {
        if (item.id === action.payload.id) {
          return { ...item, status: action.payload.status };
        }
        return item;
      });
      state.isUpdating = false;
      state.isUpdateSuccess = true;
    },
    updateJobPromotionStatusFailed: (state) => {
      state.isUpdating = false;
    },
    updateJobPromotionStatusReset: (state) => {
      state.isUpdateSuccess = false;
    },

    updateJobPromotionFilters: (state, action) => {
      state.filters = { ...state.filters, ...action.payload };
    },
  },
});

export const {
  getJobPromotions,
  getJobPromotionsSuccess,
  getJobPromotionsFailed,
  updateJobPromotionStatus,
  updateJobPromotionStatusSuccess,
  updateJobPromotionStatusFailed,
  updateJobPromotionStatusReset,
  updateJobPromotionFilters,
} = jobPromotionSlice.actions;

export default jobPromotionSlice.reducer;
